import React from "react";
import { useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import {
  isImpersonationSessionSelector,
  userRoleSelector,
  userCompanySelector,
} from "src/store/system/selector";

const useStyles = makeStyles((theme) => ({
  banner: {
    // Lives in the main content column only (right of the nav drawer).
    position: "sticky",
    top: 0,
    // Above AdminHeader AppBar (same default z-index) so title/actions don't
    // paint over this banner while scrolling.
    zIndex: theme.zIndex.appBar + 1,
    width: "100%",
    background: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
    padding: theme.spacing(1.25, 4),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: 13,
    gap: theme.spacing(1),
  },
  left: { display: "flex", alignItems: "center", gap: theme.spacing(1) },
  icon: { fontSize: 16 },
  link: {
    color: theme.palette.warning.contrastText,
    textDecoration: "underline",
    fontWeight: 500,
    whiteSpace: "nowrap",
  },
}));

/**
 * Persistent banner shown at the top of the reseller app when the session is an
 * impersonation (accountant / support) session. Hidden for normal resellers.
 */
function AccountantBanner() {
  const classes = useStyles();
  const isImpersonation = useSelector(isImpersonationSessionSelector);
  const role = useSelector(userRoleSelector);
  const company = useSelector(userCompanySelector);

  if (!isImpersonation) return null;

  const isAccountant = role === "accountant";
  const companyName = company?.name || "this account";
  const backHref = isAccountant ? "/accountant" : "/support";

  return (
    <div className={classes.banner}>
      <span className={classes.left}>
        <InfoOutlinedIcon className={classes.icon} />
        <span>
          Viewing <strong style={{ fontWeight: 500 }}>{companyName}</strong> as{" "}
          {isAccountant ? "accountant" : "support"}
        </span>
      </span>
      <a className={classes.link} href={backHref}>
        {isAccountant ? "Back to client list" : "Back to support"}
      </a>
    </div>
  );
}

export default AccountantBanner;
